var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-design-content"
  }, [_c("table-design-component")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };